import '.aq{flex-shrink:0;}.ssr-plugin'
import '.as{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ar{height:100%;}.ssr-plugin'
import '.c1{border:none;}.ssr-plugin'
import '.cv{background-color:transparent;}.ssr-plugin'
import '.cw{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.bu{position:sticky;}.ssr-plugin'
import '.cx{top:4rem;}.ssr-plugin'
import '.cy{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.cz{padding-bottom:1rem;}.ssr-plugin'
import '.d0{margin-bottom:1rem;}.ssr-plugin'
import '.d1{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bg{left:0px;}.ssr-plugin'
import '.bh{right:0px;}.ssr-plugin'
import '.bi{bottom:0px;}.ssr-plugin'
import '.d2{z-index:9999;}.ssr-plugin'
import '.d3{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bt{justify-content:flex-end;}.ssr-plugin'
import '.at{flex:1;}.ssr-plugin'
import '.br{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aq as n ar c1 cv cw"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b r"
    >
      <div className="bu cx cy v cz d0 d1 a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f bf bg bh bi d2 v d3 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="as a bt d1"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="at br">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
